<template>
  <div>
    <vx-card title="Writing Blank Type 4">
      <div v-if="editMode" class="vx-row mb-4">
        <div class="vx-col w-full">
          <p>Content code : {{ content.contentCode }}</p>
        </div>
      </div>
      
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <label>문항수</label>
          <vs-select class="mb-4" v-model="contentCount" name="item-content-count" v-on:change="changeItem">
            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in contentCountList" />
          </vs-select>

        </div>  
      </div>

      <form @submit.prevent autocomplete="off">
        <!-- <div class="form-group">
            <input type="file" @change="onFileUpload">
        </div> -->
        <div class="vx-row" :key="index" v-for="(sentence, index) in sentenceList">
          <div class="vx-col w-full">
            <vs-input class="w-full mb-2" :label="'Sentence ' + (index + 1)" v-model="sentenceList[index]" v-validate="'required'" name="sentence[]"/>
            <vs-input class="w-full mb-2" :label="'Translation ' + (index + 1)" v-model="translationList[index]" v-validate="'required'" name="translation[]"/>
          </div>
          <vs-divider border-style="dotted" color="danger" class="m-4" />
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button color="primary" class="mb-2"  @click="confirmSave">저장</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
          </div>
        </div>
      </form>
    </vx-card>  
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      menuCode: 'W023',
      sentenceList: [],
      translationList: [],
      contentCountList: [],
      contentCount: '3'
    }
  },
  props: {
    sourceContent: Object,
    editMode: Boolean,
    content: Object
  },
  computed: {
  },
  watch: {
    sourceContent () {
      this.loadContent()
    }
  },
  methods: {
    loadContent () {

      if (this.sourceContent !== null) {
        const contentJson = JSON.parse(this.sourceContent.contentBody)
        this.contentCount = contentJson.sentence.length
        
        setTimeout(function () {
        
          this.sentenceList = contentJson.sentence.slice()

          if (contentJson.hasOwnProperty('translation')) {
            this.translationList = contentJson.translation.slice()
          }

        }.bind(this), 1000)
      }
    },    
    changeItem () {
      this.sentenceList = new Array(parseInt(this.contentCount))
      this.translationList = new Array(parseInt(this.contentCount))
    },
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '알림',
        text: '저장 하시겠습니까?',
        accept: this.save,
        acceptText: '저장'
      })
    },
    async save () {
      
      if (this.$isEmptyArray(this.sentenceList)) {
        this.$vs.notify({
          title: '에러',
          text: '값을 입력해 주세요.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
        return
      } 

      if (this.$isEmptyArray(this.translationList)) {
        this.$vs.notify({
          title: '에러',
          text: '값을 입력해 주세요.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
        return
      }

      const result = {
        sentence: this.sentenceList,
        translation: this.translationList
      }
      this.$emit('onDataChanged', result)

    }
  },
  created () {

    this.contentCountList = this.$getContentsCountArray()

    if (this.editMode) {
      const contentJson = JSON.parse(this.content.contentBody)
      this.sentenceList = contentJson.sentence.slice()
      this.translationList = contentJson.translation.slice()
      this.contentCount = this.sentenceList.length
    } else {
      this.sentenceList = new Array(parseInt(this.contentCount))
      this.translationList = new Array(parseInt(this.contentCount))
    }
  }
}
</script>
